// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-icon {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sidebar-icon:hover {
  background-color: rgba(120, 103, 193, 0.25);
}

.sidebar-icon:hover::after {
  content: attr(title);
  position: absolute;
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
}

.sidebar-icon.active {
  background-color: #322a52;
  color: #fff;
}

.sidebar-icon svg,
.sidebar-icon i {
  font-size: 20px;
}

.map-main-div {
  flex: 1 1;
  position: relative;
  height: calc(100vh - 100px); /* Adjust based on your header height */
  background: #121212;
}

.mapbox-show {
  width: 100%;
  height: 100%;
}

/* Adjust the select boxes container */
.select-country-maindiv {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
  display: flex;
  gap: 10px;
}

.select-country-box {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #444;
  background: #232323;
  color: #f0f0f0;
}

.map-sidebar {
  width: 60px;
  background-color: #1e1e1e;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  box-shadow: 2px 0 8px rgba(0,0,0,0.4);
  margin-left: 30px;
  z-index: 2;
  position: relative;
}

/* Update the control positioning */
.mapboxgl-ctrl-top-left {
  left: 80px !important; /* Move controls to the right of the sidebar */
  top: 20px !important;
}

.mapboxgl-ctrl-group {
  background-color: #232323;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/Components/TrendPages/MappingPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,2BAA2B,EAAE,uCAAuC;EACpE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB,EAAE,8CAA8C;EACrE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC","sourcesContent":[".sidebar-icon {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sidebar-icon:hover {\n  background-color: rgba(120, 103, 193, 0.25);\n}\n\n.sidebar-icon:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: 50px;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n}\n\n.sidebar-icon.active {\n  background-color: #322a52;\n  color: #fff;\n}\n\n.sidebar-icon svg,\n.sidebar-icon i {\n  font-size: 20px;\n}\n\n.map-main-div {\n  flex: 1;\n  position: relative;\n  height: calc(100vh - 100px); /* Adjust based on your header height */\n  background: #121212;\n}\n\n.mapbox-show {\n  width: 100%;\n  height: 100%;\n}\n\n/* Adjust the select boxes container */\n.select-country-maindiv {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 1;\n  display: flex;\n  gap: 10px;\n}\n\n.select-country-box {\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #444;\n  background: #232323;\n  color: #f0f0f0;\n}\n\n.map-sidebar {\n  width: 60px;\n  background-color: #1e1e1e;\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  align-items: center;\n  box-shadow: 2px 0 8px rgba(0,0,0,0.4);\n  margin-left: 30px;\n  z-index: 2;\n  position: relative;\n}\n\n/* Update the control positioning */\n.mapboxgl-ctrl-top-left {\n  left: 80px !important; /* Move controls to the right of the sidebar */\n  top: 20px !important;\n}\n\n.mapboxgl-ctrl-group {\n  background-color: #232323;\n  border-radius: 4px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
